import React, { Component } from 'react';
import * as api from '../../CustomerSupportBotPage/api';
import MessageList from './MessageList';
import { matchesSupportConversation, toSupportChatUser } from '../supportBot';

export default class PendingSupportConversations extends Component {
    state = { conversations: [], cursor: null, loading: true, loadingMore: false, error: '' };
    requestId = 0;

    componentDidMount() {
        this.load();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.refreshVersion !== this.props.refreshVersion) this.load();
    }

    componentWillUnmount() {
        this.requestId += 1;
    }

    load = (more = false) => {
        if (more && (this.state.loading || this.state.loadingMore || !this.state.cursor || this.state.cursor === 'END')) return;
        const requestId = ++this.requestId;
        const { account } = this.props;
        const cursor = more ? this.state.cursor : null;
        this.setState({ loading: !more, loadingMore: more, error: '' });
        api.listPendingConversation({ language: account.language, size: 50, cursor })
            .then(page => {
                if (requestId !== this.requestId) return;
                const incoming = ((page && page.content) || []).filter(item =>
                    item.status === 'NEED_AGENT' && matchesSupportConversation(item, account));
                this.setState(prev => ({
                    conversations: Array.from(new Map(
                        (more ? prev.conversations.concat(incoming) : incoming).map(item => [item.userId, item])
                    ).values()),
                    cursor: page && page.cursor,
                    loading: false,
                    loadingMore: false,
                }));
            })
            .catch(() => {
                if (requestId !== this.requestId) return;
                this.setState({ loading: false, loadingMore: false, error: 'Không tải được các ca cần nhân viên. Vui lòng thử lại.' });
            });
    };

    render() {
        const { conversations, cursor, loading, loadingMore, error } = this.state;
        const { account, user, targetUser, cachedUsers = [], onSelect, ready } = this.props;
        const messages = conversations.map(item => toSupportChatUser(item,
            cachedUsers.find(cached => String(cached.fromUserId) === String(item.userId))));
        return (
            <div className="support-pending">
                {loading && <p className="support-bot-note" role="status">Đang tải ca cần nhân viên…</p>}
                {!ready && <p className="support-bot-note" role="status">Đang chờ kết nối nick official để mở hội thoại.</p>}
                {error && <p className="support-bot-note text-danger" role="alert">{error}</p>}
                {!loading && !error && conversations.length === 0 && (
                    <p className="support-bot-note">Chưa có ca cần nhân viên trong danh sách đã tải.</p>
                )}
                {!loading && <MessageList
                    messages={messages}
                    user={user || account}
                    targetUser={targetUser}
                    handleTargetUser={onSelect}
                    disabled={!ready}
                />}
                <button type="button" className="btn btn-sm btn-outline-secondary support-pending__more" onClick={() => this.load()} disabled={loading || loadingMore}>
                    Làm mới
                </button>
                {!loading && cursor && cursor !== 'END' && (
                    <button type="button" className="btn btn-sm btn-outline-primary support-pending__more" onClick={() => this.load(true)} disabled={loadingMore}>
                        {loadingMore ? 'Đang tải…' : 'Tải thêm ca cần nhân viên'}
                    </button>
                )}
            </div>
        );
    }
}
